var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchNavActive = function SvgSearchNavActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.054,
    cy: 11.054,
    r: 6.519,
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.388 19.388 15.74 15.74"
  })));
};
export { SvgSearchNavActive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNjQ4MjgyMTAwYmQ0MDgyNTY2ZmE2ZTljZmZiZmI4MDYuc3ZnIjs=";